import { render } from "./SelfPayStatementSentCases.vue?vue&type=template&id=587367a2"
import script from "./SelfPayStatementSentCases.vue?vue&type=script&lang=js"
export * from "./SelfPayStatementSentCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/SelfPayStatementSentCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "587367a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('587367a2', __exports__)) {
    console.log('reload')
    api.reload('587367a2', __exports__)
  }
  
  module.hot.accept("./SelfPayStatementSentCases.vue?vue&type=template&id=587367a2", () => {
    console.log('re-render')
    api.rerender('587367a2', render)
  })

}


export default __exports__